import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { TabsModule } from '../../components/tabs/tabs.module';
import { CommonComponentsModule } from '../../common-components.module';

import { DatetimeModule } from '../../components/datetime/datetime.module';
import { FieldsModule } from '../../components/fields/fields.module';
import { AngularMaterialImportModule } from '../../components/angular-material-import-module/angular-material-import.module';
import { AngularMultiSelectModule } from '../../components/angular2-multiselect-dropdown/multiselect.component';
import { SafeHtmlPipeModule } from '../../pipes/safe-html/safe-html-pipe.module';
import { WebsiteBuilderService } from '../../services/website-builder.service';
import { WebsiteBuilderComponent } from './website-builder.component';
import { WebsiteBuilderSideEditorComponent } from './website-builder-side-editor/website-builder-side-editor.component';
import { DragulaModule } from 'ng2-dragula';
import { WebsiteBuilderViewComponent } from './website-builder-view/website-builder-view.component';
import { AgmCoreModule } from '@agm/core';
import { ConstantsService } from '../../services/constants.service';
import { CorporationsListComponent } from './corporations-list/corporations-list.component';
import { SiteCarouselDirective } from './site-carousel.directive';
import { Nl2BrPipeModule } from '../../pipes/nl2br-pipe/nl2br-pipe.module';
import { WebsiteBuilderFilterComponent } from '../../components/website-builder-filter/website-builder-filter.component';
import { FileDropModule } from 'angular2-file-drop';
import { AnnouncementsModule } from '../announcements/announcements.module';
import { WebsiteBuilderImageUploadComponent } from './website-builder-side-editor/common/website-builder-image-upload/website-builder-image-upload.component';
import { WbEditAboutComponent } from './website-builder-side-editor/section/wb-edit-about/wb-edit-about.component';
import { WbEditTopBannerComponent } from './website-builder-side-editor/section/wb-edit-top-banner/wb-edit-top-banner.component';
import {UtilsModule} from '../../modules/utils/utils.module';


@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        FieldsModule,
        AngularMaterialImportModule,
        AngularMultiSelectModule,
        SafeHtmlPipeModule,
        Nl2BrPipeModule,
        DragulaModule,
        FileDropModule,
        AgmCoreModule.forRoot({
            apiKey: ConstantsService.googleMapsApiKey
        }),
        AnnouncementsModule,
        UtilsModule,
    ],
    declarations: [
        WebsiteBuilderComponent,
        WebsiteBuilderSideEditorComponent,
        WebsiteBuilderViewComponent,
        CorporationsListComponent,
        SiteCarouselDirective,
        WebsiteBuilderFilterComponent,
        WebsiteBuilderImageUploadComponent,
        WbEditAboutComponent,
        WbEditTopBannerComponent
    ],
    entryComponents: [WebsiteBuilderViewComponent],
    providers: [
        WebsiteBuilderService
    ]
})
export class WebsiteBuilderModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/website-builder/website-builder.module.ts